import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import BettingTipsStore from "@state/quick-play-store/BettingTipsStore";

export default observer(function BettingTipsPopupHeader(props: {
	store: BettingTipsStore;
}) {
	const { t } = useTranslation();

	return (
		<div className="popup__header popup--qp__header">
			<div className="popup__title">
				<i className="u-icon u-icon--base u-icon--betting-tip--str u-color--bet--returned u-mar--right--xtny" />
				<div className="popup__title__inner">
					{t("QUICK_PLAY.BETTING_TIPS.BETTING_TIP_NUMBER", {
						0: props.store.currentTipIndex,
					})}
				</div>
			</div>
			<button
				type="button"
				onClick={props.store.deactivatePopup}
				className="popup__close btn btn--square btn--square--sml btn--primary--inverted"
				title={t("COMMON.CLOSE")}
			>
				<i className="u-icon u-icon--tny u-icon--close u-color--text--secondary" />
			</button>
		</div>
	);
});
